// Background videos in the Misaj sections (hero, brand video).
//
// The Liquid `video_tag` filter writes autoplay/muted/playsinline as attributes, but
// attributes alone are not enough in practice: Safari on iOS only honours them once
// the corresponding *properties* are set, and any video that loads after a client-side
// re-render (theme editor, section reload) starts paused with no further prompting.
// Setting the properties and calling play() covers both.
(function () {
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function prepare(video) {
    if (video.dataset.misajPrepared) return;
    video.dataset.misajPrepared = '1';

    // A background film is exactly what "reduce motion" is meant to stop. Leaving it
    // on its first frame keeps the section looking finished rather than empty.
    if (REDUCED) {
      video.removeAttribute('autoplay');
      video.removeAttribute('loop');
      video.pause();
      return;
    }

    video.muted = true; // never make noise, and the price of admission for autoplay
    video.defaultMuted = true;
    video.playsInline = true;
    video.loop = true;

    var attempt = video.play();
    // Autoplay can still be refused (low power mode, strict settings). The poster stays
    // on screen in that case, which is an acceptable resting state — so swallow it.
    if (attempt && typeof attempt.catch === 'function') attempt.catch(function () {});
  }

  function scan(root) {
    (root || document).querySelectorAll('video[data-misaj-autoplay]').forEach(prepare);
  }

  scan();
  document.addEventListener('DOMContentLoaded', function () { scan(); });
  // Theme editor: sections are replaced wholesale, so the new video needs the same pass.
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();

